import moment from "moment";
import React from "react";
import { Button, Form } from "react-bootstrap";
import { defaultFormat } from "../../../../util/date";
import CustomDatePicker from "../../../CustomDatePicker";
import useBillingFilter from "./useBillingFilter";

function BillingFilter({ setFilters, theme }) {
  const {
    data,
    processing,
    handleClear,
    handleFilterSubmit,
    setData,
    practices,
  } = useBillingFilter(setFilters);

  return (
    <form className="mt-2 p-1" onSubmit={handleFilterSubmit}>
      <Form.Group>
        <Form.Label>Start Date</Form.Label>
        <CustomDatePicker
          value={
            data.startDate
              ? moment(data.startDate, defaultFormat).toDate()
              : null
          }
          name="startDate"
          onChange={(d) => {
            setData("startDate", d);
          }}
        />
      </Form.Group>

      <Form.Group>
        <Form.Label>End date</Form.Label>
        <CustomDatePicker
          value={
            data.endDate ? moment(data.endDate, defaultFormat).toDate() : null
          }
          name="endDate"
          onChange={(d) => {
            setData("endDate", d);
          }}
        />
      </Form.Group>

      <Form.Group className="m-2 text-center">
        <Button
          className={`${theme.hoverPrimaryClassButton} mt-3`}
          style={{ backgroundColor: theme.primary, color: theme.white }}
          type="submit"
        >
          Apply filters
        </Button>

        <Button
          className={`${theme.hoverSecondaryClassButton} mt-3 ml-1`}
          style={{ backgroundColor: theme.secondary, color: theme.black }}
          type="button"
          onClick={handleClear}
        >
          Reset
        </Button>
      </Form.Group>
    </form>
  );
}

export default BillingFilter;
